import Layout from '../components/layout'
import FloatButton from '../components/float-button'
import Head from 'next/head'
import Header from '../components/header'
import { createClient } from 'contentful'
import Image from 'next/image'
import Link from 'next/link'

export default function inscription(){
    return (
        <>
        <Layout>
          <Head>
            <title>PWA</title>
          </Head>
          <div className="bg-screen">
            <Header />
            
            <section className="py-28 text-white text-center bg-fixed relative">
              <Image className="z-10 absolute inset-0 object-cover" layout='fill' src="/imgs/img-bg-sombre.jpg" />
  
              <div className="container mx-auto px-5 grid grid-cols-1 gap-4 relative z-20 bg-transparent lg:grid-cols-12">
                <div className="col-span-1 lg:col-start-3 lg:col-span-8">
                  <h1 className="text-6xl font-light leading-10 mb-4">Inscription</h1>
                  <p className="text-base mb-4 font-light">Inscrivez-vous gratuitement pour participer aux débats et poser vos questions sur le forum !</p>
                </div>
              </div>
            </section>

            <section className="container mx-auto px-5 grid gap-4 grid-cols-1 py-4 lg:grid-cols-12">
                <div className="lg:col-start-3 col-span-1 lg:col-span-8 text-left">
                    <Link href="/">
                        <a className="text-color-primary">Accueil </a>
                    </Link>
                     › <Link href="/">
                        <a> Contact </a>
                    </Link>
                </div>
            </section>

            <section>
              <div className="container mx-auto px-5 py-14 grid gap-4 grid-cols-1 relative z-20 bg-transparent lg:grid-cols-12">
                <div className="lg:col-span-8 lg:col-start-3 col-span-1">
                    <div className="grid gap-4 lg:grid-cols-2 grid-cols-1">
                      
                        <div className="col-span-1">
                        <div className="md-input-box">
                                <input
                                    id="fullName"
                                    name="fullName"
                                    type="text"
                                    className="md-input"
                                    placeholder=" "
                                    />
                                <label for="fullName" className="md-label">Nom</label>
                                <div className="md-input-underline" />
                            </div>
                        </div>
                        <div className="col-span-1">
                        <div className="md-input-box">
                                <input
                                    id="fullName"
                                    name="fullName"
                                    type="text"
                                    className="md-input"
                                    placeholder=" "
                                    />
                                <label for="fullName" className="md-label">Prénom</label>
                                <div className="md-input-underline" />
                            </div>
                        </div>
                        
                        <div className="col-span-1">
                        <div className="md-input-box">
                                <input
                                    id="fullName"
                                    name="fullName"
                                    type="text"
                                    className="md-input"
                                    placeholder=" "
                                    />
                                <label for="fullName" className="md-label">Email</label>
                                <div className="md-input-underline" />
                            </div>
                        </div>
                        <div className="col-span-1">
                        <div className="md-input-box">
                                <input
                                    id="fullName"
                                    name="fullName"
                                    type="text"
                                    className="md-input"
                                    placeholder=" "
                                    />
                                <label for="fullName" className="md-label">Tel</label>
                                <div className="md-input-underline" />
                            </div>
                        </div>
                        <div className="lg:col-span-2 col-span-1">
                            <div className="md-input-box">
                                <textarea
                                    id="fullName"
                                    name="fullName"
                                    type="text"
                                    className="md-input"
                                    placeholder=" "
                                    rows="1"
                                    />
                                <label for="fullName" className="md-label">Message</label>
                                <div className="md-input-underline" />
                            </div>
                        </div>
                        <div className="lg:col-span-2 mt-4 col-span-1">
                            <button className="btn shadow-lg block btn-secondary mx-auto">Envoyer</button>
                        </div>
                    </div>
                </div>
              </div>
            </section>
            
          </div>
        </Layout>
      </>
    )
}  